// резиновый параметр для scss
document.addEventListener('DOMContentLoaded', () => {
    
    function updateScaleW() {
        // Получаем текущую ширину вьюпорта
        let width = window.innerWidth;
        
        // Опционально: можно ограничить максимальный размер, 
        // чтобы на огромных мониторах (например, 4K) элементы не становились гигантскими.
        // Если хочешь бесконечный скейл - просто удали эту строку.
        if (width > 1440) width = 1440; 
        
        // Считаем коэффициент (на 1440px будет 1, на 720px будет 0.5)
        const scaleW = width / 1440;
        
        // Передаем в глобальную CSS-переменную
        document.documentElement.style.setProperty('--scale-w', scaleW);
    }

    // Запускаем при загрузке
    updateScaleW();

    // Обновляем при ресайзе окна
    window.addEventListener('resize', updateScaleW);
});

// Функция для кнопки Back to Top
jQuery(document).ready(function($) {
    const $btn = $('#back-to-top');

    // Показываем/скрываем кнопку при скролле
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 700) {
            $btn.addClass('is-visible');
        } else {
            $btn.removeClass('is-visible');
        }
    });

    // Плавный скролл вверх при клике
    $btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 600);
    });
});


/**
 *  features на главной
 */

// jQuery(document).ready(function($) {
//     const swiperPartners = new Swiper('.home-features', {
//         slidesPerView: 'auto', 
//         loop: true,
//         spaceBetween: 16, // Отступ для мобилок (228px + 16px)
//         freeMode: true,

//         pagination: {
//             el: '.features-section .swiper-pagination',
//             clickable: true,
//         },

//         navigation: {
//             nextEl: '.features-section .swiper-button-next',
//             prevEl: '.features-section .swiper-button-prev',
//         },

//         breakpoints: {
//             // Начиная с планшетов
//             768: {
//                 spaceBetween: 30, // Отступ между большими карточками
//                 freeMode: false,
//             }
//         }
//     });
// });


/**
 *  кастомный video-player
 */

document.addEventListener('DOMContentLoaded', function() {
    const players = document.querySelectorAll('.custom-video-player');

    players.forEach(player => {
        const video = player.querySelector('video');
        const playBtn = player.querySelector('.play-pause-btn');
        const centerPlayBtn = player.querySelector('.center-play-btn');
        const playIcon = player.querySelector('.play-icon');
        const pauseIcon = player.querySelector('.pause-icon');
        const muteBtn = player.querySelector('.mute-btn');
        const volumeIcon = player.querySelector('.volume-icon');
        const muteIcon = player.querySelector('.mute-icon');
        const progressBar = player.querySelector('.progress-bar');
        const progressFilled = player.querySelector('.progress-filled');
        const volumeBar = player.querySelector('.volume-bar');
        const currentTimeEl = player.querySelector('.current-time');
        const durationTimeEl = player.querySelector('.duration-time');

        // Форматирование времени (MM:SS)
        function formatTime(seconds) {
            const min = Math.floor(seconds / 60);
            const sec = Math.floor(seconds % 60);
            return `${min}:${sec < 10 ? '0' : ''}${sec}`;
        }

        // Загрузка метаданных (время)
        video.addEventListener('loadedmetadata', () => {
            durationTimeEl.textContent = formatTime(video.duration);
        });

        // Play / Pause
        function togglePlay() {
            if (video.paused) {
                video.play();
                player.classList.remove('is-paused');
                centerPlayBtn.classList.add('is-hidden');
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            } else {
                video.pause();
                player.classList.add('is-paused');
                centerPlayBtn.classList.remove('is-hidden');
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            }
        }

        playBtn.addEventListener('click', togglePlay);
        centerPlayBtn.addEventListener('click', togglePlay);
        video.addEventListener('click', togglePlay); // Клик по самому видео тоже ставит паузу

        // Обновление ползунка и времени при проигрывании
        video.addEventListener('timeupdate', () => {
            const percent = (video.currentTime / video.duration) * 100;
            progressBar.value = percent;
            progressFilled.style.width = `${percent}%`;
            currentTimeEl.textContent = formatTime(video.currentTime);
        });

        // Перемотка видео
        progressBar.addEventListener('input', (e) => {
            const time = (e.target.value / 100) * video.duration;
            video.currentTime = time;
            progressFilled.style.width = `${e.target.value}%`;
        });

        // Громкость и Mute
        function toggleMute() {
            video.muted = !video.muted;
            if (video.muted || video.volume === 0) {
                volumeIcon.style.display = 'none';
                muteIcon.style.display = 'block';
                volumeBar.value = 0;
            } else {
                volumeIcon.style.display = 'block';
                muteIcon.style.display = 'none';
                volumeBar.value = video.volume;
            }
        }

        muteBtn.addEventListener('click', toggleMute);

        volumeBar.addEventListener('input', (e) => {
            video.volume = e.target.value;
            video.muted = false;
            if (video.volume === 0) {
                volumeIcon.style.display = 'none';
                muteIcon.style.display = 'block';
            } else {
                volumeIcon.style.display = 'block';
                muteIcon.style.display = 'none';
            }
        });
    });
});


/**
 *  скроллы
 */
document.addEventListener('DOMContentLoaded', () => {

    // ==========================================
    // 1. АВТОСКРОЛЛ К НОВОСТЯМ (При фильтрации или пагинации)
    // ==========================================
    const urlParams = new URLSearchParams(window.location.search);
    
    // Проверяем, есть ли в URL параметры news_cat или paged (пагинация)
    if (urlParams.has('news_cat') || urlParams.has('paged')) {
        const newsSection = document.querySelector('.section-news-archive');
        
        if (newsSection) {
            // Даем браузеру миллисекунду на отрисовку DOM, чтобы скролл сработал точно
            setTimeout(() => {
                // Если у тебя НЕТ фиксированной (липкой) шапки:
                newsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                
                /* 
                // РАСКОММЕНТИРУЙ ЭТОТ БЛОК, ЕСЛИ У ТЕБЯ ФИКСИРОВАННАЯ ШАПКА 
                // Иначе шапка перекроет часть табов.
                const headerHeight = 100; // Укажи высоту своей шапки в px
                const elementPosition = newsSection.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerHeight;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                */
            }, 100);
        }
    }

    // ==========================================
    // 2. ПЛАВНЫЙ СКРОЛЛ ДЛЯ ЯКОРНЫХ ССЫЛОК (href="#link")
    // ==========================================
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            
            // Пропускаем пустые ссылки (href="#"), которые часто используются для JS-событий
            if (targetId === '#') return;

            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                e.preventDefault(); // Отменяем мгновенный прыжок
                
                // Плавный скролл
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

});


    /**
     * mobile menu
     */
jQuery(document).ready(function($) {

    function hideMobMenu() {
        $('#mobile-nav-togle').removeClass('active');
        $('#mobile-menu').removeClass('active');
        pageSetScrollStop(false);
    }

    $('#mobile-nav-togle').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('#mobile-menu').removeClass('active');
            pageSetScrollStop(false);
        } else {
            $(this).addClass('active');
            $('#mobile-menu').addClass('active');
            pageSetScrollStop(true);
        }

    });
    $('#mobile-menu .overlay').on('click', function () {
        hideMobMenu()
    });
    $('#mobile-menu a').on('click', function (e) {
        e.preventDefault();
        hideMobMenu()
        location.href = this.href;
    });
    $('.mobile-menu .menu-item-has-children').on('click', function (e) {
        // $(this).toggleClass('active')
        const link = $(this);
        const width = link.outerWidth();
        // Получаем координату X клика относительно края ссылки
        const clickX = e.pageX - link.offset().left;

        // Предположим, твоя стрелочка занимает 50px справа
        const arrowArea = 70; 

        if (clickX > (width - arrowArea)) {
            // Кликнули в зону стрелочки
            e.preventDefault(); // Запрещаем переход по ссылке
            $(this).toggleClass('active')
            // const parentLi = link.parent('li');
            // parentLi.toggleClass('sub-menu-open');
            // parentLi.find('> .sub-menu').slideToggle(300);
            
        } else {
            // Кликнули по тексту ссылки
        }
    });

    /**
     * mobile menu
     */
    /**
     * Other functions
     */
    function pageSetScrollStop(set = false) {
        const $body = $('body');
        
        // Функция-заглушка для блокировки тача
        const preventDefault = (e) => {
            // 1. Ищем, есть ли среди родителей элемента, на котором палец, наше меню
            const isMenu = $(e.target).closest('.mobile-menu-inner-wraper').length > 0;

            // 2. Если это НЕ меню — блокируем скролл фона
            if (!isMenu) {
                if (e.cancelable) e.preventDefault();
            }
            // Если это меню — ничего не делаем, и браузер скроллит его как обычно
        };

        if (set) {
            // ВКЛЮЧАЕМ БЛОКИРОВКУ
            $body.addClass('stop-scrolling');
            
            // Обязательно passive: false, чтобы preventDefault сработал
            document.addEventListener('touchmove', preventDefault, { passive: false });
            window.tempScrollPrevent = preventDefault;
        } else {
            // ВЫКЛЮЧАЕМ БЛОКИРОВКУ
            $body.removeClass('stop-scrolling');
            
            document.removeEventListener('touchmove', window.tempScrollPrevent, { passive: false });
        }
    }
})




    /**
     * Подключение Magnific Popup для галерей
     */

jQuery(document).ready(function($) {
    
    // Ищем все стандартные галереи (и старые, и новые Gutenberg)
    $('.gallery, .wp-block-gallery').each(function() {
        
        // Инициализируем попап для текущей галереи
        $(this).magnificPopup({
            delegate: 'a', // Берем все ссылки внутри галереи
            type: 'image',
            gallery: {
                enabled: true, // Включаем стрелочки "вперед/назад"
                navigateByImgClick: true,
                tCounter: '<span class="mfp-counter">%curr% з %total%</span>' // Перевод счетчика
            },
            image: {
                titleSrc: function(item) {
                    // Пытаемся достать подпись из alt картинки или figcaption
                    var caption = item.el.siblings('figcaption').text();
                    var alt = item.el.find('img').attr('alt');
                    return caption ? caption : (alt ? alt : '');
                }
            }
        });
        
    });

});


// ==============================================================================
// team 
// ==============================================================================
document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.js-team-toggle');
    
    toggleButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            // Знаходимо картку, до якої належить ця кнопка
            const parentCard = this.closest('.team-card');
            
            // Перемикаємо клас
            parentCard.classList.toggle('is-open');
        });
    });
});



// ==============================================================================
// ==============================================================================

/**
 * партнеры и отзывы на главной
 */
// jQuery(document).ready(function($) {
    
//     const swiperPartners = new Swiper('.home-features', {
//         slidesPerView: 'auto', 
//         loop: true,
//         spaceBetween: 0, // Меньший отступ для мобилок
//         freeMode: true,

//         // Пагинация (точки)
//         pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//         },

//         // Навигация (стрелки)
//         navigation: {
//             nextEl: '.features-section .swiper-button-next',
//             prevEl: '.features-section .swiper-button-prev',
//         },

//         // Адаптив
//         breakpoints: {
//             // Когда ширина экрана >= 768px (планшет и выше)
//             768: {
//                 spaceBetween: 75, // Твой большой отступ для десктопа
//                 freeMode: false, // На десктопе лучше обычный скролл по слайдам
//             }
//         }
//     });
// })    
//     const testimonialSwiper = new Swiper('.testimonials', {
//         slidesPerView: 1, // Всегда 1 отзыв
//         spaceBetween: 30,
//         loop: true,
//         autoHeight: true, // Адаптация под высоту текста

//         // Навигация (стрелки)
//         navigation: {
//             prevEl: '.feedb-swiper-button-next',
//             nextEl: '.feedb-swiper-button-prev',
//         },

//         // Пагинация (точки для мобилок)
//         pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//         },

//         // Адаптив (если нужно менять поведение)
//         breakpoints: {
//             320: {
//                 allowTouchMove: true, // Можно листать пальцем
//             },
//             1024: {
//                 allowTouchMove: true, // На десктопе только кнопками (по желанию)
//             }
//         }
//     });

// })
// jQuery(document).ready(function($) {
//     // подписка
//     $('.open-popup-link').magnificPopup({
//         type: 'inline',
//         midClick: true, // Позволяет открывать по клику колесиком мыши
//         mainClass: 'mfp-fade', // Класс для анимации появления
//         removalDelay: 300,    // Задержка перед удалением (для анимации закрытия)
        
//         // Опционально: настройки закрытия
//         closeBtnInside: true,
//         showCloseBtn: true
//     });

//     $('#sendpulse-ajax-form').on('submit', function(e) {
//         e.preventDefault(); // Останавливаем переход на сайт SendPulse

//         const $form = $(this);
//         const $responseBlock = $('#form-response');
//         const url = $form.attr('action');

//         $.ajax({
//             type: "POST",
//             url: url,
//             data: $form.serialize(), // Собирает все данные из полей
//             dataType: 'html', // SendPulse обычно возвращает HTML или просто принимает данные
//             beforeSend: function() {
//                 $form.find('button').prop('disabled', true).text('Sending...');
//             },
//             complete: function() {
//                 // SendPulse часто не разрешает CORS-запросы напрямую (зависит от их настроек),
//                 // поэтому мы считаем отправку успешной, если запрос ушел.
//                 $form.fadeOut(300, function() {
//                     $responseBlock.addClass('complete');
//                 });
//             }
//         });
//     });
// })

// социалки
// document.addEventListener('DOMContentLoaded', () => {
//     const socialLinks = document.querySelectorAll('.social-buttons-wraper a');
//     const darkSections = document.querySelectorAll('.darksection');
//     const darkSectionsLG = document.querySelectorAll('.darksection-lg');
//     const mainContent = document.querySelector('main');
//     if(socialLinks && darkSections && mainContent){
//         function updateIconsStyle() {
//             const mainRect = mainContent.getBoundingClientRect();

//             socialLinks.forEach(link => {
//                 const linkRect = link.getBoundingClientRect();
//                 const linkCenter = linkRect.top + linkRect.height / 2;

//                 // 1. Проверка на выход за пределы <main>
//                 if (linkCenter < mainRect.top || linkCenter > mainRect.bottom) {
//                     link.classList.add('is-out');
//                 } else {
//                     link.classList.remove('is-out');
//                 }

//                 // 2. Проверка на нахождение над темной секцией
//                 let onDark = false;
//                 darkSections.forEach(section => {
//                     const sectionRect = section.getBoundingClientRect();
//                     if (linkCenter >= sectionRect.top && linkCenter <= sectionRect.bottom) {
//                         onDark = true;
//                     }
//                 });
//                 const width = window.innerWidth;

//                 if (width >= 768 && width <= 991) {
//                     darkSectionsLG.forEach(section => {
//                         const sectionRect = section.getBoundingClientRect();
//                         if (linkCenter >= sectionRect.top && linkCenter <= sectionRect.bottom) {
//                             onDark = true;
//                         }
//                     });
//                 }
//                 if (onDark) {
//                     link.classList.add('is-on-dark');
//                 } else {
//                     link.classList.remove('is-on-dark');
//                 }
//             });
//         }

//         // Запускаем при скролле и при загрузке
//         window.addEventListener('scroll', updateIconsStyle);
//         window.addEventListener('resize', updateIconsStyle); // на случай изменения высоты секций
//         updateIconsStyle(); 
//     }
// });



/**
 * about page
 */
// jQuery(document).ready(function($) {
//     const $nav = $('.sections-about-nav');
//     const $wrapper = $('.sections-about-nav .content-bng-wraper');
//     const $links = $('.link');
    
//     // Создаем линию, если её еще нет
//     if (!$('.nav-underline').length) {
//         $wrapper.append('<span class="nav-underline"></span>');
//     }
//     const $underline = $('.nav-underline');

//     let isManualScrolling = false;

//     function moveLine($activeLink) {
//         if (!$activeLink || $activeLink.length === 0) return;

//         // Берем нативный DOM элемент из jQuery объекта
//         const linkElement = $activeLink[0];
        
//         $underline.css({
//             'width': linkElement.offsetWidth + 'px',
//             // offsetLeft всегда стабилен внутри скролл-контейнера
//             'left': linkElement.offsetLeft + 'px' 
//         });

//         // Добавим автоматический доскролл меню на мобилках
//         if (window.innerWidth < 1024) {
//             const wrapper = $('.content-wraper')[0];
//             const scrollPos = linkElement.offsetLeft - (wrapper.offsetWidth / 2) + (linkElement.offsetWidth / 2);
            
//             $('.content-wraper').stop().animate({
//                 scrollLeft: scrollPos
//             }, 300);
//         }
//     }

//     // 1. Плавный скролл при клике
//     $links.on('click', function(e) {
//         e.preventDefault();
//         const targetId = $(this).attr('href');
//         const $target = $(targetId);

//         if ($target.length) {
//             isManualScrolling = true; // Блокируем обновление от скролла
//             // Визуально меняем сразу
//             $links.removeClass('active');
//             $(this).addClass('active');
//             moveLine($(this));

//             const navHeight = $nav.outerHeight();
//             // Вычисляем позицию с учетом высоты прилипшей навигации
//             // --- НАСТРОЙКА СМЕЩЕНИЯ ---
//             const additionalPadding = 50; // Твой дополнительный зазор в пикселях
//             // --------------------------
//             const targetPos = $target.offset().top - navHeight  - additionalPadding;

//             $('html, body').stop().animate({
//                 scrollTop: targetPos
//             }, 800, 'swing', function() {
//                 // После завершения скролла разблокируем ScrollSpy
//                 setTimeout(() => { isManualScrolling = false; }, 50);
//             });
//         }
//     });

//     // 2. Умный ScrollSpy через window scroll (надежнее для "дерганий")
//     $(window).on('scroll', function() {
//         if (isManualScrolling) return;

//         const scrollPos = $(window).scrollTop();
//         const navHeight = $nav.outerHeight();

//         $links.each(function() {
//             const targetId = $(this).attr('href');
//             const $target = $(targetId);
            
//             if ($target.length) {
//                 const targetTop = $target.offset().top - navHeight - 10;
//                 const targetBottom = targetTop + $target.outerHeight();

//                 if (scrollPos >= targetTop && scrollPos < targetBottom) {
//                     $links.removeClass('active');
//                     $(this).addClass('active');
//                     moveLine($(this));
//                 }
//             }
//         });
//     });

//     // Инициализация линии
//     $(window).on('load resize', function() {
//         moveLine($('.link.active').first() || $links.first());
//     });
// });


/**
 * Анимация "Живой фон" (Animated Blobs)
 * Скрипт находит все блоки .dynamic-bg и запускает плавное движение 
 * внутренних элементов .blob в случайных направлениях.
 */
// const initDynamicBackgrounds = () => {
//     // Находим все контейнеры динамического фона на странице
//     const backgrounds = document.querySelectorAll('.dynamic-bg');

//     backgrounds.forEach((container) => {
//         // Ищем блобы только ВНУТРИ текущего контейнера (чтобы не было конфликтов)
//         const blobs = container.querySelectorAll('.blob');

//         // Вспомогательная функция для генерации случайных координат и масштаба
//         const setPosition = (blob) => {
//             const x = Math.random() * 100;
//             const y = Math.random() * 100;
//             const scale = Math.random() * (1.2 - 0.8) + 0.8;

//             blob.style.left = `${x}%`;
//             blob.style.top = `${y}%`;
//             blob.style.transform = `translate(-50%, -50%) scale(${scale})`;
//         };

//         blobs.forEach((blob) => {
//             // 1. Инициализация: ставим блоб в случайную точку без анимации (мгновенно)
//             blob.style.transition = 'none';
//             setPosition(blob);

//             // 2. Форсируем перерисовку (Reflow), чтобы браузер применил координаты до включения анимации
//             blob.offsetHeight; 

//             // 3. Устанавливаем параметры плавного движения
//             // 7s — время одного "перелета", cubic-bezier — для органичного ускорения/замедления
//             blob.style.transition = 'all 7s cubic-bezier(0.45, 0.05, 0.55, 0.95)';

//             // 4. Запускаем первое движение через микро-паузу
//             setTimeout(() => {
//                 setPosition(blob);
//             }, 50);

//             // 5. Зацикливаем движение. 
//             // Интервал чуть меньше (6800мс), чем время транзиции (7000мс), 
//             // чтобы движение было непрерывным и мягким.
//             setInterval(() => setPosition(blob), 6800);
//         });
//     });
// };
// Запуск при полной загрузке DOM
// document.addEventListener('DOMContentLoaded', initDynamicBackgrounds);



/**
 * для организаций на странице about свайпер
 */
// document.addEventListener('DOMContentLoaded', () => {
//     let swiperInstance = null;

//     const initSwiper = () => {
//         const container = document.querySelector('.key-areas-support .organizers');
//         if (!container) return;

//         const isDesktop = window.innerWidth >= 1670;

//         if (isDesktop && swiperInstance) {
//             swiperInstance.destroy(true, true);
//             swiperInstance = null;
//         } 
//         else if (!isDesktop && !swiperInstance) {
//             swiperInstance = new Swiper(container, {
//                 slidesPerView: 'auto', 
//                 loop: true,
//                 spaceBetween: 0, // Меньший отступ для мобилок
//                 // freeMode: true,
//                 freeMode: { sticky: true },
//                 // Пагинация (точки)
//                 pagination: {
//                     el: '.swiper-pagination',
//                     clickable: true,
//                 },
//             });
        
//         }
//     };

//     initSwiper();
//     window.addEventListener('resize', initSwiper);
// });


/**
 * Тогл на фокусы страница about
 */
// document.addEventListener('DOMContentLoaded', () => {
//     const focuses = document.querySelectorAll('.focuses .focuse');

//     focuses.forEach(item => {
//         item.addEventListener('click', (e) => {
//             // Выполняем только на мобилках
//             if (window.innerWidth < 768) {
//                 // Если кликнули по самой кнопке или где-то в районе лого/имени
//                 // но не внутри открытого описания (чтобы можно было выделить текст)
//                 if (!e.target.closest('.description-inner')) {
//                     item.classList.toggle('is-open');
//                 }
//             }
//         });
//     });
// });




/**
 * партнеры на about
 */
// jQuery(document).ready(function($) {
//     // Сначала инициализируем Swiper (
//     const swiperPartners = new Swiper('.page-about .partners', {
//         slidesPerView: 2, // Сколько столбиков видно одновременно
//         grid: {
//             rows: 1, // По умолчанию 1 ряд (мобилка)
//             fill: 'row',
//         },
//         spaceBetween: 20,
//         pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//         },
//         navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//         },
//         breakpoints: {
//             // Планшет (MD)
//             768: {
//                 slidesPerView: 3, 
//                 grid: {
//                     rows: 3, // 3 логотипа вертикально
//                 },
//                 spaceBetween: 30
//             },
//             // Десктоп (XL/XXL)
//             1200: {
//                 slidesPerView: 4, // Например, 4 колонки
//                 grid: {
//                     rows: 2, // 2 логотипа вертикально
//                 },
//                 spaceBetween: 40
//             }
//         },
//         on: {
//             touchStart: function() {
//                 // Закрываем все открытые tippy при начале касания/свайпа
//                 if (typeof tippy !== 'undefined') {
//                     // hideAll() — это встроенный метод Tippy.js
//                     tippy.hideAll();
//                 }
//             },
//             // На всякий случай добавим закрытие при программной смене слайда
//             slideChange: function() {
//                 if (typeof tippy !== 'undefined') {
//                     tippy.hideAll();
//                 }
//             }
//         }
//     });

//     // Инициализация Tippy
//     if (typeof tippy !== 'undefined' && $('.page-about .partner').length > 0) {
//         const tippyInstances = tippy('.page-about .partner', {
//             content(reference) {
//                 const popover = reference.querySelector('.popover');
//                 // Проверяем: есть ли блок и не пустой ли в нем HTML
//                 if (popover && popover.innerHTML.trim() !== '') {
//                     return popover.innerHTML;
//                 }
//                 return null; 
//             },
//             allowHTML: true,
//             interactive: true,
//             trigger: 'click', // Открываем по клику
//             theme: 'primary-theme',
//             appendTo: () => document.body,
//             hideOnClick: true, // Закрывать при клике в пустое место
            
//             // Главная настройка:
//             // Позволяет закрывать текущий поповер при клике на его же триггер
//             // и переключаться между разными
//             onShow(instance) {
//                 // Если контент не был получен (null), отменяем показ
//                 if (!instance.props.content) {
//                     return false; 
//                 }
//                 // Закрываем все остальные открытые поповеры перед показом текущего
//                 // Это и создает эффект "одного окна"
//                 const allInstances = document.querySelectorAll('.partner');
//                 allInstances.forEach(el => {
//                     if (el._tippy && el._tippy !== instance) {
//                         el._tippy.hide();
//                     }
//                 });
//             },
            
//             popperOptions: {
//                 strategy: 'fixed',
//             }
//         });
//     }
// })




/**
 * команда на about
 */
// jQuery(document).ready(function($) {
//     let teamSwiper = null;

//     function initTeamSwiper() {
//         const screenWidth = window.innerWidth;
//         const swiperContainer = '.team-peoples';

//         if (screenWidth < 768) { // До планшета (MD)
//             if (!teamSwiper) {
//                 teamSwiper = new Swiper(swiperContainer, {
                   
//                     slidesPerView: 'auto', 
//                     spaceBetween: 20,
//                     // spaceBetween: 0, // Меньший отступ для мобилок
//                     // freeMode: true,
//                     enabled: true,
//                     autoHeight: true,

//                     // Пагинация (точки)
//                     pagination: {
//                         el: '.swiper-pagination',
//                         clickable: true,
//                     },

//                 });
//             }
//         } else {
//             if (teamSwiper) {
//                 teamSwiper.destroy(true, true);
//                 teamSwiper = null;
//             }
//         }
//     }

//     // Запуск при загрузке и ресайзе
//     initTeamSwiper();
//     $(window).on('resize', initTeamSwiper);
// });


// // let browserName = false;

// // 
// //bacground video
// jQuery(document).ready(function($) {
//     /**
//      * Image popup
//      */
//     // $('.image-popup-magnific').magnificPopup({
//     //     type: 'image',
//     //     closeOnContentClick: true,
//     //     mainClass: 'mfp-img-mobile',
//     //     image: {
//     //         verticalFit: true
//     //     }
//     // });
    
//     $('a[rel="gallery"]').magnificPopup({
//         type: 'image',
//         closeOnContentClick: true,
//         mainClass: 'mfp-img-mobile',
//         gallery: {
//             enabled: true, // Это самое важное
//             navigateByImgClick: true,
//             preload: [0, 1] // Предзагрузка: [предыдущая, следующая]
//         },
//         image: {
//             verticalFit: true
//         }
//     });
    
//     $('.video-youtube-popup').magnificPopup({
//         type: 'iframe',
//         iframe: {
//             patterns: {
//                 youtube: {
//                     index: 'youtube.com/',
//                     id: 'v=',
//                     // Добавляем enablejsapi=1, чтобы мы могли управлять плеером через JS
//                     src: '//www.youtube.com/embed/%id%?autoplay=1&mute=0&enablejsapi=1'
//                 }
//             }
//         },
//         callbacks: {
//             open: function() {
//                 // Как только попап открылся, находим iframe и посылаем команду playVideo
//                 const $iframe = this.content.find('iframe');
                
//                 // Ждем чуть-чуть, пока фрейм загрузится, и пушим команду
//                 $iframe.on('load', function() {
//                     this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
//                 });
//             }
//         }
//     });

// })



// Функция для получения куки и gdpr
// jQuery(document).ready(function($) {
//     const $popup = $('#cookie-popup');
    
//     // Показываем плашку плавно (если PHP её вывел в DOM)
//     if ($popup.length > 0) {
//         $popup.delay(400).fadeIn(500); // Показываем с небольшой задержкой
//     }

//     $('#gdpr-confirm').on('click', function(e) {
//         e.preventDefault();

//         // Устанавливаем куку через JS (чтобы совпало с проверкой PHP)
//         const expiryDate = new Date();
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1); // На 1 год
        
//         document.cookie = "gdpr_accepted=1; expires=" + expiryDate.toUTCString() + "; path=/; SameSite=Lax";

//         $popup.fadeOut(300);
//     });
// });


// jQuery(document).ready(function($) {

    
//     // add a property to the video item for checking whether the video is already playing or not
//     Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
//         get: function () {
//             return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
//         }
//     });

//     //To do that add a event listener for ‘suspend’ to show your UI for playing video manually
//     // const videoElement = document.getElementById('hero-video-bg');
//         // videoElement.addEventListener('suspend', () => {
//         //     // suspend invoked
//         //     // show play button
//         // });

//         // videoElement.addEventListener('play', () => {
//         //     // video is played
//         //     // remove play button UI
//         // });
        

//     $('body').on('click touchstart', function () {
//         const videoElement = document.getElementById('hero-video-bg');
//         if(videoElement){
//             if (videoElement.playing) {
//                 // video is already playing so do nothing
//             }
//             else {
//                 // video is not playing
//                 // so play video now
//                 videoElement.play();
//             }
//         }
//     });
// })

// jQuery(document).ready(function($) {

//     //hidden recaptcha 
//     setTimeout(()=>{    
//         $('.grecaptcha-badge').parent().addClass('recaptcha-unvisible')
//     },1000)

//     // create table scroller
//     function wrap(el, wrapper, className = 'table-wrapper') {
//         console.log('create table scroller')
//         if(el){
//             el.parentNode.insertBefore(wrapper, el);
//             wrapper.appendChild(el);
//             wrapper.classList = className;
//         }
//       }
//     //   wrap(document.querySelector('table'), document.createElement('div'));
//     // var elList = document.querySelectorAll('table');
//     // console.log(Array.from(elList));
//     Array.from(document.querySelectorAll('.content table')).forEach(el => {
//             el.style.width = null;
//             wrap(el, document.createElement('div'))
//     })


//     //   $('.content table').each(function(el){
//     //     console.log(el)
//     //    wrap(el, document.createElement('div'));
//     // });



// })

// jQuery(document).ready(function($) {

//     /**
//      * accordion-toggle
//      */
//     $('.accordion-toggle').on('click', function () {
//         let parent = $(this).parent();
//         parent.toggleClass('collapse');
//         if (parent.hasClass('collapse')) {
//             const hCollapser = 32 + parent.find('.collapser-inner').outerHeight()*1.003 ;

//             parent.find('.collapser').css('height', hCollapser + 'px');
//         } else {
//             parent.find('.collapser').css('height', '0px');
//         }
//     })

//     /**
//      * Image popup
//      */
//     // $('.image-popup-magnific').magnificPopup({
//     //     type: 'image',
//     //     closeOnContentClick: true,
//     //     mainClass: 'mfp-img-mobile',
//     //     image: {
//     //         verticalFit: true
//     //     }
//     // });
    
//     // $('a[rel="gallery"]').magnificPopup({
//     //     type: 'image',
//     //     closeOnContentClick: true,
//     //     mainClass: 'mfp-img-mobile',
//     //     image: {
//     //         verticalFit: true
//     //     }
//     // });
    
//     // $('.video-youtube-popup').magnificPopup({
//     //     type: 'iframe',
        
//     //     iframe: {
//     //        markup: '<div class="mfp-iframe-scaler">'+
//     //                   '<div class="mfp-close"></div>'+
//     //                   '<iframe class="mfp-iframe" frameborder="0" allowfullscreen autoplay></iframe>'+
//     //                 '</div>'
//     //     },
//     //     callbacks: {
//     //       markupParse: function(template, values, item) {
//     //        values.title = item.el.attr('title');
//     //       }
//     //     }
        
        
//     //   });

//     /**
//      * resolve brauser problem
//      */
//     if (navigator.vendor.match(/google/i)) {
//         browserName = 'chrome';
//     } else if (navigator.vendor.match(/apple/i)) {
//         browserName = 'safari';
//     } else if (navigator.userAgent.match(/firefox\//i)) {
//         browserName = 'firefox';
//     } else if (navigator.userAgent.match(/edge\//i)) {
//         browserName = 'edge';
//     } else if (navigator.userAgent.match(/trident\//i)) {
//         browserName = 'ie';
//     } else {
//         browserName = navigator.userAgent + "\n" + navigator.vendor;
//     }


//     /**
//      * link scroll to #link
//      */
//     $(document).on('click', 'a[href^="#"]', function (e) {
//         if ($(this).attr('href') == '#pll_switcher') {
//         return false;
//         }// target element id
//         if ($(this).attr('href') == '#') {
//             return;
//         }
//         // target element
//         var $id = $($(this).attr('href'));
//         if ($id.length === 0) {
//             return;
//         }
//         // console.log($id)
//         // prevent standard hash navigation (avoid blinking in IE)
//         e.preventDefault();

//         // top position relative to the document
//         var pos = $id.offset().top;

//         // animated top scrolling
//         $('body, html').animate({scrollTop: pos - 75});
//     });


//     /**
//      * Init Scrolling
//      */
//     const container = document.querySelector('#mobile-menu-inner-wraper');
//     const ps = new PerfectScrollbar(container);


    
//     /**
//      * external click
//      */
//     // $(document).mouseup(function (e) {
//     //     let searchBox = $("#search-box");
//     //     let searchIco = $("#search-ico");
//     //     if (searchBox.has(e.target).length === 0 && searchIco.has(e.target).length === 0) {
//     //         closeSearchBox();
//     //     }
//     // });

//     /**
//      * external click
//      */


//     /**
//      * mobile menu
//      */
//     function hideMobMenu() {
//         $('#mobile-nav-togle').removeClass('active');
//         $('#mobile-menu').removeClass('active');
//         pageSetScrollStop(false);
//     }

//     $('#mobile-nav-togle').on('click', function () {
//         if ($(this).hasClass('active')) {
//             $(this).removeClass('active');
//             $('#mobile-menu').removeClass('active');
//             pageSetScrollStop(false);
//         } else {
//             $(this).addClass('active');
//             $('#mobile-menu').addClass('active');
//             pageSetScrollStop(true);
//         }
//     });
//     $('#mobile-menu .overlay').on('click', function () {
//         hideMobMenu()
//     });
//     $('#mobile-menu a').on('click', function (e) {
//         e.preventDefault();
//         hideMobMenu()
//         location.href = this.href;
//     });
//     $('.mobile-menu .menu-item-has-children').on('click', function () {
//         $(this).toggleClass('active')
//     });

//     /**
//      * mobile menu
//      */

//     /**
//      * header search
//      */
//     $('#search-ico').on('click', function (e) {
//         e.preventDefault();
//         if ($(this).hasClass('active')) {
//             closeSearchBox();
//         } else {
//             // console.log('focus')
//             $('#search-box').addClass('active')
//             $(this).addClass('active')
//             $('#search-field').focus()
//         }
//     });

//     function closeSearchBox() {
//         $('#search-ico').removeClass('active')
//         $('#search-box').removeClass('active')
//     }

//     /**
//      * header search
//      */

//     // startHeightMobileMenu();
//     // function startHeightMobileMenu() {
//     //     $('.menu-item-has-children .sub-menu').map((indx, element) => {
//     //         $(this).height()
//     //
//     //         // if ($(this).offset().top > window.scrollY + $(window).height()) {
//     //         //     $(this).addClass('beforeanimat ' + animFadeInUp);
//     //         //     $(this).removeClass('aftereanimat ' + animFadeInUp);
//     //         // }
//     //     });
//     // }


//     /**
//      * Other functions
//      */
//     function pageSetScrollStop(set = false) {
//         if (!set) {
//             $('body').removeClass('stop-scrolling')
//             $('body').bind('touchmove', function (e) {
//                 e.preventDefault()
//             })
//         } else {
//             $('body').addClass('stop-scrolling')
//             $('body').unbind('touchmove')
//         }
//     }

//     /**
//      * open report pdf
//      */

//     //  var filter_report = $('select[name=select-report]').select2({
//     //     minimumResultsForSearch: -1,
//     //     // dropdownCssClass: 'vacancies_select2',
//     // });

//     $('.btn-show-report').on('click', function (e) {
//         e.preventDefault();

//         const reportType = $(this).data('report-type');
//         const repurt_url = $('select[name="select-report"] option:selected').data(reportType);
//          if (!mobileCheck()){
//             $('.report-embed-pdf-frame').addClass('show');
        

//             // document.getElementById("embed-pdf-viever").setAttribute("src", repurt_url);

//             // window.open(repurt_url, '_blank').focus();

       
//             $('#embed-pdf-wraper').html('<iframe src="'+repurt_url+'#toolbar=0&navpanes=0&scrollbar=0" frameborder="0" scrolling="no" id="embed-pdf-viever"  type="application/pdf"></iframe>');
//         }else{
//             // changeUrlEmbed(valueUria)
//             let finishUrl = `https://drive.google.com/viewerng/viewer?embedded=true&url=${repurt_url}#scrollbars=0&toolbar=0&statusbar=0&navpanes=0`;
//             window.open(finishUrl, '_blank');
//         }

        

//         // var source ="http://uf.loc/wp-content/uploads/2021/06/Konsolidovana-fin-zvitnist_2020_MTK.pdf";
//         // var embed = document.getElementById('embed-pdf-viever');
//         // var clone = embed.cloneNode(true);
//         // clone.setAttribute('src', source);
//         // embed.parentNode.replaceChild(clone, embed)

//     });

//     $('select[name="select-report"]').on('change', function (e) {
//         $('.report-embed-pdf-frame').removeClass('show');
//         $('#embed-pdf-wraper').empty();
//         // document.getElementById("embed-pdf-viever").setAttribute("src", '');
//     })
//     /**
//      * open report pdf
//      */


//     /**
//      * open poll in popup
//      */
//     //  $('.ajax-popup-link').magnificPopup({
//     //     items: {
//     //       src: 'https://docs.google.com/forms/d/e/1FAIpQLSeBpJmyDo1RM5oxqKHnvBrrsKqKeVnSy7VudkgPE5x6BocUMw/viewform'
//     //     },
//     //     type: 'iframe'
//     //   });
//     /**
//      * open poll in popup
//      */





//     /**
//      * header popup contact-page head email
//      */
//     $('.hidden-email').on('click', function (e) {
        
//         let mail =  $(this).data('mail');
//         mail = mail.replace("#","@")
//         $(this).text(mail);
//         window.location.href = "mailto:"+mail;
        
//     })
       
//     /**
//      * header popup contact-page head email
//      */

//     /**
//      * header popup contact-us
//      */
//     $('#search-ico').on('click', function (e) {
//         e.preventDefault();
//     });

//     $('.contact-us-popup').on('click', function (e) {
//         console.log('.contact-us-popup')
//         e.preventDefault();
//         $.magnificPopup.open({
//             items: {
//                 src: '#contactForm',
//                 type: 'inline'
//             },
//             // focus: '#your-name',
//             callbacks: {
//                 beforeOpen: function () {
//                     $('body').css('overflow', 'hidden');
                    
//                     if ($(window).width() < 700) {
//                         this.st.focus = false;
//                     } else {
//                         this.st.focus = '#name';
//                     }
//                     $('.file-box').find('.wpcf7-file').val('');
//                     $('.file-box').find('.fileformlabel').text('');
//                     $('.file-box').addClass('hide');
//                     $('.file-box').removeClass('file');
//                     ;
//                     $('.file-box').first().removeClass('hide');
//                     $('.wpcf7-response-output').html('')
//                     $('.wpcf7-not-valid-tip').html('')
//                     $('.wpcf7-form-control').removeClass('wpcf7-not-valid');
//                 },
//                 open: function () {
//                     $('.mfp-wrap').css('overflow', 'auto');
//                 },
//                 beforeClose: function () {
//                     $('body').css('overflow', 'auto');
//                 },
//             }
//         })
//     });

//     $('a.del-file').on('click', function (e) {
//         e.preventDefault();

//         $(this).closest('.file-box').find('.wpcf7-file').val('');
//         $(this).closest('.file-box').find('.fileformlabel').text('');
//         $(this).closest('.file-box').addClass('hide');
//         $(this).closest('.file-box').removeClass('file');
//     });
    
//     $('.file-box input').change(function () {
//         var nameFile = $(this).val().split('\\'),
//         nameFileLast = nameFile[nameFile.length - 1];
    
//         $(this)
//             .closest('.file-box')
//             .find('.fileformlabel')
//             .text(nameFileLast);
    
//         $(this).closest('.file-box').removeClass('hide');
//         $(this).closest('.file-box').addClass('file');
//         $(this).closest('.file-box').next().removeClass('hide');
//     });

//     function clearPopupContactUs(){
//         $('#contactForm .file-box').find('.wpcf7-file').val('');
//         $('#contactForm .file-box').find('.fileformlabel').text('');
//         $('#contactForm .file-box').addClass('hide');
//         $('#contactForm .file-box').removeClass('file');

//         $('#contactForm .file-box').first().removeClass('hide');

//         $('#contactForm input[type="text"]').val('')
//         $('#contactForm input[type="email"]').val('')
//         $('#contactForm textarea').val('')
//     }
//         // reset form after send
    
//         var wpcf7Elm = document.querySelector( '.wpcf7' );
//         if(wpcf7Elm){
//             wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
//                 clearPopupContactUs();
//             }, false );
//         }
    
//     //ajax version
//     // $('.contact-us-popup').magnificPopup({
//     //     type: 'ajax',
//     //     callbacks: {
//     //         ajaxContentAdded: function() {
//     //           // Ajax content is loaded and appended to DOM
//     //           console.log(this.content);
//     //             $('a.del-file').on('click', function (e) {
//     //                 e.preventDefault();

//     //                 $(this).closest('.file-box').find('.wpcf7-file').val('');
//     //                 $(this).closest('.file-box').find('.fileformlabel').text('');
//     //                 $(this).closest('.file-box').addClass('hide');
//     //                 $(this).closest('.file-box').removeClass('file');
//     //             });

//     //             $('.file-box input').change(function () {
//     //                 var nameFile = $(this).val().split('\\'),
//     //                     nameFileLast = nameFile[nameFile.length - 1];

//     //                 $(this)
//     //                     .closest('.file-box')
//     //                     .find('.fileformlabel')
//     //                     .text(nameFileLast);

//     //                 $(this).closest('.file-box').removeClass('hide');
//     //                 $(this).closest('.file-box').addClass('file');
//     //                 $(this).closest('.file-box').next().removeClass('hide');
//     //             });
//     //             $('.wpcf7-select').select2({
//     //                 minimumResultsForSearch: Infinity
//     //             });
                
//     //         }
//     //       }
//     //   });

//     // popup Request a Quote




//     // $('a.del-file').on('click', function (e) {
//     //     e.preventDefault();

//     //     $(this).closest('.file-box').find('.wpcf7-file').val('');
//     //     $(this).closest('.file-box').find('.fileformlabel').text('');
//     //     $(this).closest('.file-box').addClass('hide');
//     //     $(this).closest('.file-box').removeClass('file');
//     // });

//     // $('.file-box input').change(function () {
//     //     var nameFile = $(this).val().split('\\'),
//     //         nameFileLast = nameFile[nameFile.length - 1];

//     //     $(this)
//     //         .closest('.file-box')
//     //         .find('.fileformlabel')
//     //         .text(nameFileLast);


//     //     $(this).closest('.file-box').removeClass('hide');
//     //     $(this).closest('.file-box').addClass('file');
//     //     $(this).closest('.file-box').next().removeClass('hide');
//     // });
//     /**
//      * header popup contact-us
//      */
// });


// /**
//  * set preloader
//  */
// // function setPreloaderInElementByID(id, append = false) {
// //     let preloader = document.getElementById('preloader-origin').innerHTML
// //     if (append) {
// //         document.getElementById(id).insertAdjacentHTML('beforeend', preloader);
// //     } else {
// //         document.getElementById(id).innerHTML = preloader
// //     }
// // }

// /**
//  * set preloader
//  */



//  window.mobileCheck = function() {
//     let check = false;
//     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//     return check;
// };


